import React from "react";
import { connect } from 'react-redux';
import { DocumentCard,
    DocumentCardDetails,
    DocumentCardTitle } from '@fluentui/react';
import { QARType } from "./../../GlobalConst/globalEnums";
import { PrimaryButton } from '@fluentui/react';


class QARTask extends React.Component {

    getQARMessage(qarTaskType) {
        let message;

        switch (qarTaskType)
        {
            case QARType.quarterlyConfidential: {
                message =   <div>
                                <p><b>Dear {this.props.user.displayName}</b></p>
                                <p>{this.props.user.role === 'Administrator' ? '' : 'You are administrator of'} SharePoint Site/Application <b><a href={`${this.props.task.site.url}`} target='_blank'>{this.props.task.site.title}</a></b> {this.props.user.role === 'Administrator' ? '' : 'that'} contains {this.props.task.site.confidentiality} data and we would like to remind you about your responsibility to perform quarterly access review.</p>
                                <p>Please confirm completing the action using button below.</p>
                            </div>;
                break;
            }
            
            case QARType.quarterlyOnline: {
                message =   <div>
                                <div>Dear {this.props.user.displayName},</div>
                                <div>{this.props.user.role === 'Administrator' ? '' : 'You are administrator of'} SharePoint Site/Application <b>{this.props.task.site.title}</b> {this.props.user.role === 'Administrator' ? '' : 'that'} contains data shared with Everyone/Everyone except external and we would like to remind you about your responsibility to perform quarterly access review. We kindly ask you to confirm that content shared with “Everyone” or/and “Everyone except externals” has been checked, is shared intentionally, and in full accordance with ABB's policy.</div>
                                <div>Please confirm completing the action using button below.</div>
                            </div>;
                break;
            }

            case QARType.quarterlyOneDrive: {
                message = <div>
                                <div><b>Dear {this.props.user.displayName},</b></div>
                                <div>Your personal OneDrive contains data shared with Everyone/Everyone except externals and we would like to remind you about your responsibility to perform quarterly access review. We kindly ask you to confirm that content shared with “Everyone” or/and “Everyone except externals” has been checked, is shared intentionally, and in full accordance with ABB's policy. </div>
                                <div>Please confirm completing the action using button below.</div>
                          </div>;
                break;
            }
            default: {

            }
        }

        return message;
    };

    getThankYouMessage() {
        return  <div>
                    <p>Thank you for taking the time, we appreciate your response.</p>
                    <p>If you have any questions, feel free to send us an email at <a href='mailto:PL-ABBCollaboration@abb.com'>PL-ABBCollaboration@abb.com</a></p>
                    <p>Regards</p>
                </div>
    }

    _onLocationClick = (e) => {
        e.stopPropagation();
        e.preventDefault();

        window.open(e.target.href, '_blank');
    }

    render() {
        const cardTitle = this.props.task.site ? this.props.task.site.title : this.props.task.user.displayName;

        const qarTask = <DocumentCard styles={QARcardStyles} >
                            <DocumentCardDetails styles={detailsStyles} >
                                {
                                    !this.props.inDialog &&
                                    <div style={QARtitleStyles}>
                                        <DocumentCardTitle title={cardTitle} shouldTruncate={false} />
                                    </div>
                                }
                                <div style={messageStyles}>
                                    {this.getQARMessage(this.props.task.type)}
                                </div>                       
                            </DocumentCardDetails>
                            <div style={btnStyles}>
                                <PrimaryButton disabled={this.props.isSaving} onClick={this.props.onApprove} text="Review finished" />   
                            </div>
                        </DocumentCard>
        const thankYouPage = <DocumentCard styles={QARcardStyles} >
                                <DocumentCardDetails styles={detailsStyles} >
                                    <div style={messageStyles}>
                                        {this.getThankYouMessage()}
                                    </div>                       
                                </DocumentCardDetails>
                                <div style={btnStyles}>
                                    <PrimaryButton onClick={this.props.closeDialog} text="Close" />      
                                </div>   
                            </DocumentCard>

        return (
            <div style={{display: 'inline-block'}}>
                {
                    this.props.showThankYouPage
                        ? thankYouPage
                        : qarTask
                }
                
            </div>
        );
    }
}

const btnStyles = {
    display: 'flex',
    flexDirection:'column'
}

const messageStyles = {
    padding: '0 12px',
    fontSize: '13px',
    overflowY: 'auto'
}


const QARtitleStyles = {
    display: 'flex',
    flexDirection: 'row'
}

const QARcardStyles = {
    root: {
        marginRight: 20,
        marginBottom: 20,
        width: 400,
        height: 300,
        border: '1px solid grey',
    }
};

const detailsStyles = {
    root: {
        height: 268,
        wordBreak: 'break-word',
        justifyContent: 'flex-start'
    }
}

const mapStateToProps  = state => ({
    user: state.user.currentUser
})

export default connect(mapStateToProps, null)(QARTask);


// WEBPACK FOOTER //
// ./src/components/ManageCenter/QARTask.js